import React from 'react';
import { useSelector } from 'react-redux';

import Modal from "../../../../../components/Modal";
import messages from "../../../../../assets/locale/messages";

const DeleteManualAddedServiceModal = ({
    open,
    setOpen,
    selectedService
}) => {

    const lang = useSelector((state) => state.locale.lang);
    const { branches, shared } = messages[lang];

    const isMultiSession = selectedService?.service_type === "multi_session";
    const titleKey = isMultiSession 
        ? "deleteManualServiceSessionsTitle" 
        : "deleteManualServiceTitle";
    const contentKey = isMultiSession 
        ? "deleteManualServiceSessionsContent" 
        : "deleteManualServiceContent";

    return(
        <Modal
            open={open}
            handleClose={()=>setOpen(false)}
            title={<span className="fsize-26 fweight-400">{branches.addBranch.specialtiesAndServices[titleKey]}</span>}
            contentClass="mb-3 pb-2 text-primary"
            content={<p>{branches.addBranch.specialtiesAndServices[contentKey]}</p> }
            confirmBtnTxt={shared.delete}
            cancelBtnTxt={shared.cancel}
            isContentText={false}
            handleConfirm={()=>{}}
            handleCancel={()=>setOpen(false)}
            maxWidth="sm"
            actionsClass=" px-4"
            confirmBtnClass="btn-secondary fsize-14 text-white py-2 px-5"
            cancelBtnClass="fsize-14 py-2 text-secondary px-5 "
        />
    )
};

export default DeleteManualAddedServiceModal;